import * as React from 'react';
import { useEffect } from 'react';
import SvgImage from '../SvgImage';
import { CSS_CLASSES } from '../../../configs';
import './styles.scss';

const bodyElm = document.body;

interface OverlayProps {
  children: JSX.Element | JSX.Element[];
  handleClose: Function;
  style?: string;
  id?: string;
  hasCloseRedirect?: boolean;
  containerLess?: boolean;
}

const Overlay = ({
  children,
  handleClose,
  style,
  id,
  hasCloseRedirect,
  containerLess,
}: OverlayProps) => {
  const closeOverlay = () => {
    bodyElm.classList.remove(CSS_CLASSES.overlayIsShowing);
    /* timeout to allow animations to complete. */
    if (hasCloseRedirect) {
      handleClose();
      return;
    }
    setTimeout(() => {
      handleClose();
    }, 100);
  };

  const handleKeyUp = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    if (event.keyCode === 27) {
      closeOverlay();
    }
  };

  useEffect(() => {
    bodyElm.classList.add(CSS_CLASSES.overlayIsShowing);
    /**
     * This needs some rework - note quite sure why it's built this way tbh
     */
    // @ts-ignore
    window.addEventListener('keyup', handleKeyUp);
    // @ts-ignore
    return () => window.removeEventListener('keyup', handleKeyUp);
  }, []);

  return (
    <div className={`overlay ${style && `overlay--${style}`}`} id={id || ''}>
      <div className={containerLess ? '' : 'container'}>
        <button className="overlay__close" onClick={() => closeOverlay()}>
          <span className="visually-hidden">Close</span>
          <SvgImage title="close icon" reference="#icon-close" />
        </button>
        <div className="overlay__content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Overlay;
